// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"251":"7d951a0b","491":"d94598bb","744":"e2e86b6b","992":"8bfd66ee"}[chunkId] + ".chunk.css";
};